import React, { useContext, useEffect, useState } from 'react'
import { GlobalAgGridTable } from '../Deal/AgGridReactComponent/GlobalAgGridTable'
import { Button, message } from 'antd';
import swal from "sweetalert";
import CreateTeams from './CreateTeams';
import AwsServerService from '../../common/util/AwsServerService';
import { AppDataRequired } from '../../App';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { canAccess } from '../../common/util/appUtils';

export default function Teams() {
    const userinfo = JSON.parse(localStorage.getItem("userinfo"));
    const [allTeams, setAllTeams] = useState([])
    const accessContext = useSelector(state => state.UserContext.accessContext);
    const { AllUsers } = useContext(AppDataRequired);
    const [allCacheTeams, setAllCacheTeams] = useState([])
    const [allCacheRoles,setAllRoles] = useState([])
    const [openTeamsModal, setOpenTeamsModal] = useState({data: null, open: false, type: "create" })
    const fetRoles = () => {
        AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "ROLES" }).then(res => { 
          console.log(res.data); 
          setAllRoles(res.data);
        }).catch(err => {
          console.log(err);
        })
      }
    useEffect(()=>{
        fetRoles();
        reloadTeams();
    },[])
    function reloadTeams(){
        AwsServerService.CrudServiceHandler({method:'GET',data:'',route:'TEAMS'}).then(res=>{
            setAllTeams(res.data);
            setAllCacheTeams(res.data);
        }).catch(err=>{
            setAllTeams([])
        })
    }
    const actionListCellRenderer = (params) => { 
            const canEdit = canAccess(accessContext, "Teams", "Edit")
            const canDelete = canAccess(accessContext, "Teams", "Delete")
            let btnDiv = document.createElement("div");
            btnDiv.classList.add("global-action-btn-for-tables"); 
            let editBtn = document.createElement('button');
            editBtn.classList.add("add")
            editBtn.innerText = "Edit"
            editBtn.id = params.ROWID;
            editBtn.addEventListener('click', (e) => {  
                if(!canEdit){
                    message.error("Permission Denied.");
                    return;
                }
                let Rowid = e.currentTarget.id;
                if (params.ROWID == Rowid) {
                    setOpenTeamsModal({ open: true, data: { ...params }, type: "edit" });
                }
            })
            let deleteBtn = document.createElement('button');
            deleteBtn.classList.add("add")
            deleteBtn.style.color = "red";
            deleteBtn.innerText = "Delete";
            deleteBtn.id = params.ROWID;
            deleteBtn.addEventListener('click', (e) => {
                if(!canDelete){
                    message.error("Permission Denied.");
                    return;
                }
                let Rowid = e.currentTarget.id;
                swal({
                    title: "Warning!",
                    text: `Are you sure you want to delete the Team?`,
                    icon: "warning",
                    buttons: {
                        cancel: "Cancel",
                        confirm: "Proceed",
                    },
                }).then(async (isDelete) => {
                    if (isDelete) {
                        AwsServerService.CrudServiceHandler({ method: "DELETE", data: {ROWID:Rowid}, route: "TEAMS" }).then(res => {
                            reloadTeams()
                        })
                    }
                })
            })
            btnDiv.appendChild(editBtn);
            btnDiv.appendChild(deleteBtn);
            return btnDiv;
        }
        const getAccountMailIds = (data) => { 
            if(data && data.length==0){
              return "";
            }
            let emailId=[]; 
            for (let index = 0; index < data.length; index++) {
              const value = data[index]; 
              if(AllUsers?.some(e=>e.zuid == value)){
                let mail = AllUsers?.find(e=>e.zuid == value)?.full_name;
                emailId.push(mail);
            }else{
                  let userId=allCacheRoles?.find(e=>e.ROWID==value); 
                  emailId.push(`${userId?.RoleName} (${userId?.RoleType})`);
              } 
            }
            return emailId.join(", ");
          }
    const teamsCols = [
        {
            field: "Team_Name",
            name: "Team Name",
            path: "Team_Name",
            type: "text",
            // key: "UserId",
            label: "Team Name",
            id: 0,
            isChecked: false,
            isDragOver: false,
            isSearch: false
        },  
        {
            field: "CREATEDBY",
            name: "Created By",
            path: "CREATEDBY",
            key: "CREATEDBY",
            type: "text",
            label: "Created By",
            id: 3,
            isChecked: false,
            isDragOver: false,
            isSearch: false,
            content: (obj) => {
                return (AllUsers?.filter(user=>user.zuid==obj.CREATEDBY)[0].full_name)||"N/A";
            },
        },
        {
            field: "CREATEDTIME",
            name: "Created Time",
            path: "CREATEDTIME",
            key: "CREATEDTIME",
            type: "text",
            label: "Created Time",
            id: 3,
            isChecked: false,
            isDragOver: false,
            isSearch: false,
            content: (obj) => {
                return moment(obj?.CREATEDTIME).format('MM-DD-YYYY HH:MM');
            },
        },
        {
            field: "MODIFIEDBY",
            name: "Modified By",
            path: "MODIFIEDBY",
            key: "MODIFIEDBY",
            type: "text",
            label: "Modified By",
            id: 3,
            isChecked: false,
            isDragOver: false,
            isSearch: false,
            content: (obj) => {
                return (AllUsers?.find(user => user.zuid == obj.MODIFIEDBY)?.full_name) ?? "N/A";
            },
        },
        {
            field: "MODIFIEDTIME",
            name: "Modified Time",
            path: "MODIFIEDTIME",
            key: "MODIFIEDTIME",
            type: "text",
            label: "Modified Time",
            id: 3,
            isChecked: false,
            isDragOver: false,
            isSearch: false,
            content: (obj) => {
                return moment(obj?.MODIFIEDTIME).format('MM-DD-YYYY HH:MM');
            },
        },
        {
            field: "Members",
            name: "Members",
            path: "Members",
            key: "Members",
            type: "text",
            label: "Members",
            id: 3,
            isChecked: false,
            isDragOver: false,
            isSearch: true,
            content: (obj) => {
                return getAccountMailIds(obj.Members,"type");
            },
        },
        {
            field: "Action",
            key: "Action",
            name: "Action",
            path: "Action",
            type: "text",
            label: "Action",
            id: 4,
            isChecked: false,
            isDragOver: false,
            isSearch: true,
            content: actionListCellRenderer,
        },
    ];
    
    const extraComponentToRightForUserRole = (e) => {
        return (
            <div className="extra-component-request-toRight">
                <div className="job-action-box">
                    <Button
                        style={canAccess(accessContext, "Teams", "Create") ? {} : {opacity: 0.2, pointerEvents: "none", cursor: "not-alloweds"}}
                        type='primary'
                        className="mr-3 request-btns"
                        onClick={() => {
                            setOpenTeamsModal({data: null, open: true, type: "create" });
                        }}
                    >
                        Create Team
                    </Button>
                </div>
            </div>
        );
    }
  return (  <>
          {<CreateTeams openTeamsModal={openTeamsModal} onCancel={()=>setOpenTeamsModal({data: null, open: false, type: "create" })} reloadTeams={reloadTeams}/>}
          <div id="myGrid" className='ag-theme-alpine Blueprint-Body'>
                    <GlobalAgGridTable
                        headers={teamsCols}
                        setRowData={setAllTeams}
                        cacheRowData={allCacheTeams}
                        setCacheRowData={setAllCacheTeams}
                        module="Teams"
                        mainUrl="Teams" 
                        rowData={allTeams}
                        renderExtraComponent={() => <></>}
                        renderExtraComponentToRight={extraComponentToRightForUserRole}
                        isTaskFilterHide={true}
                    />
                </div>
                </> 
  )
}
